import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTopOnRouteChange = () => {
  const { pathname, hash } = useLocation();

  // Disable the browser's default scroll restoration so it never overrides us.
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    if (hash) return; // hash-anchor handlers will manage scroll for #section links
    const reset = () => {
      window.scrollTo(0, 0);
      if (document.documentElement) document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
    };
    reset();
    // Re-assert after first paint (catches framer entrance animations) and
    // again after a short delay (catches late-loading hero images that shift layout).
    const r1 = requestAnimationFrame(reset);
    const t1 = setTimeout(reset, 100);
    const t2 = setTimeout(reset, 350);
    return () => {
      cancelAnimationFrame(r1);
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [pathname, hash]);
  return null;
};
